import { mapState } from "vuex";

export const metatags = {
  // define data() -> seoData
  computed: {
    ...mapState(["resumeData"]),
  },
  methods: {
    handleTitleTemplate() {
      let str = this.$route.path == "/" ? "" : this.resumeData.model;
      return str + " " + this.seoData.titleTemplate;
    },
  },
  metaInfo() {
    return {
      title: `${this.seoData.title}`,
      titleTemplate: `%s - ${this.handleTitleTemplate()}`,
      meta: [
        { content: this.seoData.author },
        { name: "description", content: this.seoData.og_description },
        { property: "og:description", content: this.seoData.og_description },
        { property: "og:title", content: this.seoData.og_title },
        { property: "og:locale", content: this.seoData.og_locale },
        { property: "og:type", content: this.seoData.og_type },
        { property: "og:site_name", content: this.seoData.og_site_name },
      ],
      // htmlAttrs: {
      //     lang: 'pt',
      //     amp: true
      // },
      // meta: [
      //     { name: 'author', content: this.seoData.author},
      //     { vmid: 'description', name: 'description', content: this.seoData.og_description},
      //     { vmid: 'og:description', property: 'og:description', content: this.seoData.og_description},
      //     { vmid: 'og:title', property: 'og:title', content: this.seoData.og_title},
      //     { vmid: 'og:locale', property: 'og:locale', content: this.seoData.og_locale},
      //     { vmid: 'og:type', property: 'og:type', content: this.seoData.og_type},
      //     { vmid: 'g:site_name', property: 'og:site_name', content: this.seoData.og_site_name},
      // ],
    };
  },
};
